import app from 'app';

import articleColumns from './article/article-columns';

app.add({
  'article-columns': articleColumns,
});
